// Redux/reducers/departmentReducer.js
import {
  DEPARTMENT_REQUEST,
  DEPARTMENT_SUCCESS,
  DEPARTMENT_FAIL,
  DEPARTMENT_ADD_REQUEST,
  DEPARTMENT_ADD_SUCCESS,
  DEPARTMENT_ADD_FAIL,
  DEPARTMENT_ADD_RESET,
  DEPARTMENT_DELETE_REQUEST,
  DEPARTMENT_DELETE_SUCCESS,
  DEPARTMENT_DELETE_FAIL,
  DEPARTMENT_DELETE_RESET,
} from "../../constants/adminConstants/departmentConstants.js";

const initialState = {
  departments: [],
  loading: false,
  error: null,
  successAdd: false,
  successDelete: false,
};

export const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEPARTMENT_REQUEST:
      return { ...state, loading: true };
    case DEPARTMENT_SUCCESS:
      return { ...state, loading: false, departments: action.payload };
    case DEPARTMENT_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DEPARTMENT_ADD_REQUEST:
      return { ...state, loading: true };
    case DEPARTMENT_ADD_SUCCESS:
      return { ...state, loading: false, successAdd: true };
    case DEPARTMENT_ADD_FAIL:
      return { ...state, loading: false, error: action.payload };
    case DEPARTMENT_ADD_RESET:
      return { ...state, successAdd: false };

    case DEPARTMENT_DELETE_REQUEST:
      return { ...state, loading: true };
    case DEPARTMENT_DELETE_SUCCESS:
      return { ...state, loading: false, successDelete: true };
    case DEPARTMENT_DELETE_FAIL:
      return { ...state, loading: false, error: action.payload };
    case DEPARTMENT_DELETE_RESET:
      return { ...state, successDelete: false };

    default:
      return state;
  }
};
